var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.currentSortProperty == _vm.sortProperty && _vm.reverse == false)?_c('b-icon-sort-down'):(_vm.currentSortProperty == _vm.sortProperty && _vm.reverse == true)?_c('b-icon-sort-up'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }